import { render, staticRenderFns } from "./addLottory.vue?vue&type=template&id=fb89b38e&scoped=true"
import script from "./addLottory.vue?vue&type=script&lang=js"
export * from "./addLottory.vue?vue&type=script&lang=js"
import style0 from "./addLottory.vue?vue&type=style&index=0&id=fb89b38e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb89b38e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb89b38e')) {
      api.createRecord('fb89b38e', component.options)
    } else {
      api.reload('fb89b38e', component.options)
    }
    module.hot.accept("./addLottory.vue?vue&type=template&id=fb89b38e&scoped=true", function () {
      api.rerender('fb89b38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operation/components/addLottory.vue"
export default component.exports